import { isUndefined } from 'ply-utils'

const SEPARATOR = '::'

const parseMessage = (message) => message && JSON.parse(message)

const getMessageValue = (message) => {
	const res = parseMessage(message)

	return res ? res.args.value : null
}

const getContent = (message) => {
	const value = getMessageValue(message)
	if (value.indexOf('Welcome') === 0) {
		return { value }
	}

	const splitIndex = value.indexOf(SEPARATOR)
	const contentPart =
		splitIndex > -1 ? value.substring(splitIndex + SEPARATOR.length) : value

	return contentPart && JSON.parse(contentPart)
}

const parse = (message) => {
	const content = getContent(message)
	const { ns } = content
	const success = isUndefined(content.success) ? true : content.success

	return {
		ns,
		content,
		success,
	}
}

const defaultParse = (message) => {
	try {
		return parse(message)
	} catch (_e) {
		console.warn(`[webSocket] failed to parse message`, message)
		return null
	}
}

export { defaultParse as default }
